import getTitleBasedOnPathname from './getTitleBasedOnPathname';

export default getTitleBasedOnPathname;
